export default "__VITE_ASSET__DTpir6BY__"